import React from "react";
import { useSelector, useDispatch } from "types/store";
import { Button, Accordion } from "aible";
import TextInput from "components/Inputs/TextInput";
import Tooltip from "components/Inputs/Tooltip";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import { isEnabled } from "utils/featureFlags";
import styles from "./style.module.css";
const AdditionalOptions = ({ nextId } = {}) => {
    const dispatch = useDispatch();
    nextId = useSelector((state) => nextId ?? nextReducer.getCurrentNextId(state));
    const isNextSaving = useSelector((state) => nextReducer.getIsSavingReport(state, nextId));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const disableButtons = isAsking === true || isNextSaving;
    const promptMultiDocSummary = useSelector((state) => chatGPTReducer.getPromptMultiDocSummary(state));
    const resetPromptMultiDocSummary = () => dispatch(chatGPTReducer.resetPromptMultiDocSummary());
    return (React.createElement("div", { className: styles.chatSettingsItem },
        React.createElement(Accordion, { header: React.createElement("div", { className: styles.chatSettingsItemHeader }, "Additional Options (not specific to your selected agent template)") },
            React.createElement("div", { className: styles.setting, style: { paddingLeft: "10px" } }, isEnabled("multi-document-dataset") && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.settingLabel },
                    "Multi Document Summary Message",
                    React.createElement(Tooltip, { overlay: "This will have the LLM attempt to summarize multiple segments of information into one document." }),
                    React.createElement(Button, { isSmall: true, type: "secondary", style: { marginLeft: "auto" }, onClick: () => resetPromptMultiDocSummary() }, "Reset")),
                React.createElement(TextInput, { className: styles.settingPrompt, value: promptMultiDocSummary, onChange: (val) => dispatch(chatGPTReducer.updatePromptMultiDocSummary(val)), isDisabled: disableButtons })))))));
};
export default AdditionalOptions;
